/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosEnumSectionSizes, EmbedSectionFragment } from "@cosmos/hygraph-schema";

import {
	BackgroundContainer,
	ResponsiveContainer,
	SectionContainer,
	CosmosEmbed,
	SectionHeading,
} from "@components/elements";
import { Box, VStack } from "@panda/jsx";
import { css, cx } from "@panda/css";

export const smStyles = css({
	maxWidth: `cosmos.article.sm`,
});

export const mdStyles = css({
	maxWidth: `cosmos.article.md`,
});

export const lgStyles = css({
	maxWidth: `cosmos.article.lg`,
});

export const EmbedSection = ({
	config,
	size = CosmosEnumSectionSizes.Md,
	embed,
}: EmbedSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(embed?.iframeSrc);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer>
					<VStack alignItems="stretch" gap="eds.dimension.56" className="embed-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<Box w="full">
								<Box
									className={cx(
										size === "sm" ? smStyles : null,
										size === "md" ? mdStyles : null,
										size === "lg" ? lgStyles : null,
									)}
									marginInline={config?.heading?.centeredVerticalStack ? "auto" : "unset"}
								>
									<CosmosEmbed {...embed} />
								</Box>
							</Box>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
